// extracted by mini-css-extract-plugin
export default {"section":"Education_section__pWYMf","heading":"Education_heading__6uyFd","cards":"Education_cards__8Yky4"};